export default __webpack_public_path__ + "static/media/ic_invisibility.d88ef7b1.svg";